import type { IntlShape } from 'react-intl';

import { SVGIcons } from '@/components/atoms/Icon/SVGIcon';
import { computeText } from '@/locales/utils';
import { theme } from '@/core/theme';

export const buildBannerStatusBadge = (isActive: boolean, intl: IntlShape) => ({
    icon: isActive ? SVGIcons.CHECK : SVGIcons.CROSS_INHERIT,
    text: computeText(
        intl,
        isActive ? 'promotionalBanner.table.statusActive' : 'promotionalBanner.table.statusInactive',
    ),
    textColor: isActive ? theme.savory.colors.success[900] : theme.savory.colors.warning[700],
    backgroundColor: isActive ? theme.savory.colors.success[100] : theme.savory.colors.warning[100],
});

export const buildBannerLinkTypeCell = (linkInfo: { badgeText: string; subtitle?: string }) => ({
    type: 'badgeSubtitle' as const,
    value: {
        badge: {
            text: linkInfo.badgeText,
            textColor: theme.savory.colors.neutral[900],
            backgroundColor: theme.savory.colors.neutral[100],
        },
        subtitle: linkInfo.subtitle,
    },
});
